// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3LdYK","loginContainer":"App_loginContainer__3e4au","langContainer":"App_langContainer__1doCJ","lg_login_btn_btm_1":"App_lg_login_btn_btm_1__C19HT"};